module.exports = __webpack_public_path__ + "img/logo.8840dc1a.png";